module.exports = __webpack_public_path__ + "img/contract_top1.93c98a44.png";